import { FormField, FormSelect } from "@/components/Drawer";
import useMaster from "@/hooks/useMaster";
import { EMPTY_FINANCE } from "@/lib/constants";

export default function FinanceBlock({ value, onChange }) {
  const { items: financiers } = useMaster("/financiers");
  const v = value || EMPTY_FINANCE;
  const set = (k, val) => onChange({ ...v, [k]: val });
  const financeType = (v.finance_type || "loan").toLowerCase();
  const financierOptions = [
    { value: "", label: "— Select financier —" },
    ...financiers.map((f) => ({ value: f.id, label: f.branch ? `${f.name} (${f.branch})` : f.name })),
  ];
  return (
    <div className="border border-canvas-line p-3 space-y-3" data-testid="finance-block">
      <div className="flex items-center justify-between">
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-muted">
          Finance Details
        </div>
        <div className="flex items-center gap-1 border border-canvas-line" data-testid="finance-type-toggle">
          {[
            { v: "loan", l: "Loan" },
            { v: "lien", l: "Lien" },
          ].map((opt) => (
            <button
              key={opt.v}
              type="button"
              onClick={() => set("finance_type", opt.v)}
              data-testid={`finance-type-${opt.v}`}
              className={`px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest ${
                financeType === opt.v ? "bg-ink text-white" : "hover:bg-canvas-panel"
              }`}
            >
              {opt.l}
            </button>
          ))}
        </div>
      </div>
      {financeType === "lien" && (
        <div className="px-2 py-1.5 border border-ink/30 bg-canvas-panel/60 text-[10px] leading-snug">
          <span className="font-mono uppercase tracking-widest text-ink">LIEN with financier:</span>{" "}
          the ₹500 Hypothecation charge is auto-excluded from the customer&apos;s on-road. Any balance
          from the lien financier will appear under Finance Receivables (not Retail Cash Due).
        </div>
      )}
      <FormSelect
        label="Financier"
        value={v.financier_id}
        onChange={(x) => set("financier_id", x)}
        options={financierOptions}
        testId="finance-financier"
      />
      <div className="grid grid-cols-3 gap-3">
        <FormField
          label={financeType === "lien" ? "Lien Balance (₹)" : "Finance Amount (₹)"}
          type="number"
          value={v.finance_amount}
          onChange={(x) => set("finance_amount", Number(x) || 0)}
          testId="finance-amount"
        />
        <FormField
          label="DO Number"
          value={v.do_number}
          onChange={(x) => set("do_number", x)}
          testId="finance-do"
        />
        <FormField
          label="Commission (₹)"
          type="number"
          value={v.commission_amount}
          onChange={(x) => set("commission_amount", Number(x) || 0)}
          testId="finance-commission"
        />
      </div>
    </div>
  );
}
